import type { Action } from 'redux';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const FetchMauLimit = new ReduxAsyncAction<'FETCH_MAU_LIMIT', void, number>('FETCH_MAU_LIMIT');

FetchMauLimit.registerRequest(async () => {
  const URI = '/v1/usage/mau/count-data';

  try {
    const countData = await dash_api.get<{ limit: number }>(URI);
    return countData?.data?.limit;
  } catch (e) {
    throw e;
  }
});

export const FETCH_MAU_LIMIT = FetchMauLimit.actionNamespaceConstants;

export const fetchMauLimit = FetchMauLimit.request;

export type FetchMauLimitResponseAction = Action<typeof FETCH_MAU_LIMIT.response> & { data: number };
